function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.508 6.65c.259-.964 2.068-2.314 2.429-2.217.36.097 1.253 2.17.995 3.134-.259.963-1.234 1.54-2.18 1.286-.945-.254-1.501-1.24-1.244-2.203z",
  fill: "#E6E9ED"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.56 9.903a.333.333 0 0 1-.322-.42l.728-2.716a.334.334 0 0 1 .644.172l-.728 2.716a.333.333 0 0 1-.322.248z",
  fill: "#CCD1D9"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.607 9.514l-1.911.59L7.19 5.22l1.912-.588 1.504 4.882z",
  fill: "#ED5564"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.695 4.14L5.598 5.712l.048-2.108 4.46-1.373.589 1.91z",
  fill: "#434A54"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.41 10.01L9.876 8.875l.452-1.008 1.094-.416 1.021.458.417 1.094-.452 1.007zm-1.652-1.47l1.316.59.066-.148-.22-.578-.518-.232-.578.22-.066.147z",
  fill: "#000"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.588 3.825c.106.047.153.172.106.278l-1.848 4.12a.21.21 0 0 1-.278.106l-1.539-.69a.211.211 0 0 1-.106-.279l1.847-4.12a.211.211 0 0 1 .279-.105l1.539.69z",
  fill: "#A0D468"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.964 7.945a.337.337 0 0 1-.136-.029c-.168-.075-.243-.272-.168-.44l1.32-2.945a.334.334 0 0 1 .609.272l-1.32 2.945a.333.333 0 0 1-.305.197z",
  fill: "#8CC153"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.665 7.333H1.332V14h13.333V7.333zM14.332 3.334H1.666V4h12.666v-.666z",
  fill: "#F6BB42"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4 10H2a.333.333 0 1 1 0-.666h2A.333.333 0 0 1 4 10zM13.999 9.333h-1.334a.333.333 0 1 1 0-.666H14a.333.333 0 1 1 0 .666zM2.666 12.667H2A.333.333 0 1 1 2 12h.666a.334.334 0 0 1 0 .667zM14 12.334h-2.334c-.85 0-1.276.457-1.484.84-.212.39-.235.77-.237.811V14h.668c.006-.063.037-.3.164-.524.181-.32.472-.476.89-.476H14a.333.333 0 1 0 0-.666z",
  fill: "#DBA037"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 2H0v12h2V2zM16 2h-2v12h2V2z",
  fill: "#FFCE54"
});

var SvgSdk = function SvgSdk(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

export default __webpack_public_path__ + "static/media/sdk.18d798cd.svg";
export { SvgSdk as ReactComponent };